import { Component, Injectable } from '@angular/core'

import { Facility } from '../model/facility'
import { SelectedRecordFacilitatorService } from './selected-record-facilitator.service'

export interface FacilitiesComponent extends Component {
  facility: Facility
  isDirty(): boolean
}

@Injectable()
export class FacilitiesService extends SelectedRecordFacilitatorService<Facility> {
  get location() {
    return this.record
  }

  get locations() {
    return this.records
  }

  loadHandler() {
    return this.clinicService.getLocations({ includeDisabled: true }, true)
  }
}
